<template>
  <div style="background: white; border-radius: 5px;">
    <HeaderTaxInvoice @getListTaxInvoice="getTaxInvoiceList"/>
    <hr style="padding: 0; margin: 0"/>
    <div style="padding:15px 20px" v-loading="loading">

      <div
          style="display: flex; flex-direction: column; gap: 15px; padding: 10px 0">
        <div class="grid-filter">
          <div class="display-flex-column">
            <span>Mã hóa đơn thuế</span>
            <el-input
                placeholder="Tìm theo mã hóa đơn thuế"
                suffix-icon="el-icon-search"
                clearable
                v-model="queryFilter.tax_code"
                @input="onlyNumberTaxCode"
                @change="handleSearch"
            >
            </el-input>
          </div>
          <div class="display-flex-column">
            <span>Mã hóa đơn nạp</span>
            <el-input
                placeholder="Tìm theo mã hóa đơn nạp"
                suffix-icon="el-icon-search"
                clearable
                @input="onlyNumberTaxInvoice"
                v-model="queryFilter.amount_id"
                @change="handleSearch"
            > 
            </el-input>
          </div>
          <div class="display-flex-column">
            <span>Mã phát hành</span>
            <el-input
                placeholder="Tìm theo mã phát hành"
                suffix-icon="el-icon-search"
                clearable
                v-model="queryFilter.release_code"
                @change="handleSearch"
            >
            </el-input>
          </div>
          <div class="display-flex-column">
            <span>Tên khách hàng</span>
            <el-input
                placeholder="Nhập tên khách hàng"
                suffix-icon="el-icon-search"
                clearable
                v-model="queryFilter.user_name"
                @change="handleSearch"
            >
            </el-input>
          </div>
          <div class="display-flex-column">
            <span>Số điện thoại</span>
            <el-input
                placeholder="Nhập số điện thoại"
                suffix-icon="el-icon-search"
                v-model="queryFilter.phone"
                clearable
                @change="handleSearch"
            >
            </el-input>
          </div>
          <div class="display-flex-column">
            <span>Thời gian tạo</span>
            <el-date-picker
                style="width: 100%"
                v-model="queryFilter.created_at"
                type="daterange"
                align="right"
                start-placeholder="Thời gian bắt đầu"
                end-placeholder="Thời gian kết thúc"
                format="dd-MM-yyyy"
                clearable
                value-format="yyyy-MM-dd"
                :default-value="new Date()"
                @change="handleSearch"
            >
            </el-date-picker>
          </div>
          <div class="display-flex-column">
            <span>Thời gian phát hành</span>
            <el-date-picker
                style="width: 100%"
                v-model="queryFilter.release_time"
                type="daterange"
                align="right"
                start-placeholder="Thời gian bắt đầu"
                end-placeholder="Thời gian kết thúc"
                format="dd-MM-yyyy"
                clearable
                value-format="yyyy-MM-dd"
                :default-value="new Date()"
                @change="handleSearch"
            >
            </el-date-picker>
          </div>
          <div class="display-flex-column">
            <span>Trạng thái</span>
            <el-select v-model="queryFilter.status" style="width: 100%" clearable multiple collapse-tags
                       placeholder="Chọn trạng thái bản ghi" @change="handleSearch">
              <el-option
                  v-for="item in statusInvoice"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="display-flex-column">
            <span>Phân loại</span>
            <el-select v-model="queryFilter.type" style="width: 100%" clearable multiple collapse-tags
                       placeholder="Chọn phân loại bản ghi" @change="handleSearch">
              <el-option
                  v-for="item in typeInvoice"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="display-flex-column">
            <span>Trung tâm</span>
            <el-select v-model="queryFilter.center_id" style="width: 100%" clearable multiple
                       placeholder="Chọn chọn trung tâm" @change="handleSearch">
              <el-option
                  v-for="item in centers"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="display-flex-column">
            <span>Pháp nhân</span>
            <el-select v-model="queryFilter.legal_entity" multiple style="width: 100%" clearable
                       placeholder="Chọn pháp nhân" @change="handleSearch">
              <el-option
                  v-for="item in juridicalOption"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="example-preview table-responsive h-100 mt-8">
        <table class="table table-vertical-center table-bordered">
          <thead>
          <tr style="background-color: #F8F8F8;">
            <th scope="col" class="w-[40px]" style="background: #F8F8F8; text-align: start">Mã hóa đơn thuế</th>
            <th scope="col" class="min-w-[80px]" style="background: #F8F8F8;white-space: nowrap; text-align: start">Mã hóa đơn</th>
            <th scope="col" class="min-w-[80px]" style="background: #F8F8F8;white-space: nowrap; text-align: start">Mã phát hành</th>
            <th scope="col" class="min-w-[40px]" style="background: #F8F8F8; text-align: start;">Phân loại</th>
            <th scope="col" class="min-w-[80px]" style="background: #F8F8F8; text-align: start">Trạng thái</th>
            <th scope="col" class="min-w-[80px]" style="background: #F8F8F8; text-align: start; white-space: nowrap">Tên khách hàng</th>
            <th scope="col" class="min-w-[80px]" style="background: #F8F8F8; text-align: start; white-space: nowrap">Số điện thoại</th>
            <th scope="col" class="min-w-[120px]" style="background: #F8F8F8; text-align: start; white-space: nowrap">Số tiền đóng</th>
            <th scope="col" class="min-w-[150px]" style="background: #F8F8F8; text-align: start">Thời gian tạo</th>
            <th scope="col" class="min-w-[180px]" style="background: #F8F8F8; white-space: nowrap; text-align: start">Ngày phát hành</th>
            <th scope="col" class="w-100px" style="background: #F8F8F8">Hành động</th>
          </tr>
          </thead>
          <tbody v-if="TaxInvoiceList?.length > 0">
          <tr v-for="invoice of TaxInvoiceList" :key="invoice?.id" style="border: 1px solid #EBEDF3; border-top: 0">
            <td style="text-align: start">
              {{ invoice.id }}
            </td>
            <td style="text-align: start">
              {{ invoice.codeInvoice }}
            </td>
            <td style="text-align: start">
              {{ invoice.releaseCode }}
            </td>
            <td>
              {{ invoice.typeString }}
            </td>
            <td>
                <span :class="invoice.bgStatus" style="padding: 4px 8px; border-radius: 5px; white-space: nowrap">
                  {{ invoice.statusString }}
                </span>
            </td>
            <td style="text-align: start">
              <p style="white-space: nowrap">{{ invoice.name }}</p>
            </td>
            <td style="text-align: start">
              {{ invoice.phone }}
            </td>
            <td style="text-align: start">
              {{ invoice.amount }}
            </td>
            <td style="text-align: start">
              {{ invoice.createdAt }}
            </td>
            <td style="text-align: start">
              {{ invoice.releaseDate }}
            </td>
            <td style="text-align: center">
              <button v-if="invoice.showButton === 1" class="btn btn-icon btn-xs btn-outline-danger" title="Hủy phát hành" @click="cancelRelease(invoice, 4)">
                <i class="el-icon-delete"></i>
              </button>
              <button v-if="invoice.showButton === 2" class="btn btn-icon btn-xs btn-outline-primary" title="Dừng phát hành" @click="cancelRelease(invoice, 2)">
                <i class="fa-solid fa-stop"></i>
              </button>
            </td>
          </tr>
          </tbody>
          <tbody v-else>
          <tr>
            <td colspan="12" class="event-title no-data" style="text-align: center">Chưa có dữ liệu</td>
          </tr>
          </tbody>
        </table>
        <div v-if="TaxInvoiceList?.length > 0">
          <div class="edu-paginate mx-auto text-center mt-10 mb-5"
               style="display: flex; justify-content: center; align-items: center; height: 50px">
            <paginate
                v-model="page"
                :page-count="lastPage"
                :page-range="3"
                :margin-pages="1"
                :click-handler="changePage"
                :prev-text="'Trước'"
                :next-text="'Sau'"
                :container-class="'pagination b-pagination'"
                :pageLinkClass="'page-link'"
                :next-link-class="'next-link-item'"
                :prev-link-class="'prev-link-item'"
                :prev-class="'page-link'"
                :next-class="'page-link'"
                :page-class="'page-item'"
            >
            </paginate>
          </div>
          <div class="w-100" style="display: flex; justify-content: end; margin-top: -50px">
            <div>
              Tổng số bản ghi: <span
                style="color: #0066FF; font-weight: 600; margin-left: 5px;">{{
                this.total ?? TaxInvoiceList.length
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog width="30%" :title="`Xác nhận ${statusSelectedInvoice === 2 ? 'dừng' : 'hủy'} phát hành hóa đơn: ${taxInvoiceSelected.name}`" :show-close="false" :visible.sync="confirmCancel" v-if="confirmCancel">
      <hr style="padding: 0; margin-top: -20px"/>
      <span v-if="statusSelectedInvoice === 2" style="word-break: break-word">Bạn có chắc chắn muốn dừng phát hành hóa đơn này?</span>
      <div v-else style="word-break: break-word">
        <p style="word-break: break-word">Trường hợp hóa đơn đã phát hành thành công, cần đảm bảo đã thao tác hủy phát hành hóa đơn trên phần mềm MISA.</p>
        <span style="word-break: break-word">Bạn có chắc chắn muốn hủy phát hành hóa đơn này?</span>
      </div>
      <div style="display: flex; justify-content: end; margin-top: 20px">
        <el-button type="info" @click="confirmCancel = false">Đóng</el-button>
        <el-button type="danger" @click="handleCancelRelease">{{ statusSelectedInvoice === 2 ? "Dừng" : "Hủy" }} phát hành</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {juridicalOption, statusInvoice, typeInvoice} from "@/common/define";
import {
  GET_LIST_TAX_INVOICE,
  UPDATE_STATUS_TAX_INVOICE
} from "@/core/services/store/tax-invoice/tax-invoice.module";
import {TaxInvoiceModel} from "./model/TaxInvoiceModel";
import {GET_CENTER_TAG_E} from "@/core/services/store/task-management/task-management.module";
import HeaderTaxInvoice from "@/view/pages/tax-invoice/components/HeaderTaxInvoice.vue";

export default {
  components: { HeaderTaxInvoice },
  data() {
    return {
      loading: false,
      page: 1,
      lastPage: 1,
      total: 0,
      TaxInvoiceList: [],
      statusInvoice,
      typeInvoice,
      juridicalOption,
      centers: [],
      confirmCancel: false,
      taxInvoiceSelected: null,
      statusSelectedInvoice: null,
      queryFilter: {
        tax_code: null,
        amount_id: null,
        release_code: null,
        user_name: null,
        phone: null,
        created_at: [],
        release_time: [],
        status: null,
        type: null,
        center_id: null,
        legal_entity: null,
      },
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Quản lý báo cáo"},
      {title: "Hóa đơn thuế", name: 'TaxInvoiceList'}
    ]);
    this.getTaxInvoiceList()
    this.getAllCenterActive()
  },
  methods: {
    changePage(obj) {
      this.page = obj;
      this.getTaxInvoiceList()
    },
    getTaxInvoiceList(payload = null) {
      if (payload && payload.amount_id !== undefined) {
        this.queryFilter.amount_id = payload.amount_id
        this.page = 1
        this.callApi()
        return
      }
      this.getParams()
      this.callApi()
    },
    async handleSearch() {
      await this.queryFilterTaxInvoice()
      this.getTaxInvoiceList()
    },

    callApi() {
      this.loading = true
      const payload = {
        page: this.page,
        tax_code: this.queryFilter.tax_code,
        amount_id: this.queryFilter.amount_id,
        release_code: this.queryFilter.release_code ?? null,
        user_name: this.queryFilter.user_name,
        phone: this.queryFilter.phone ?? null,
        created_at: this.queryFilter.created_at,
        release_time: this.queryFilter.release_time,
        status: this.queryFilter.status ?? null,
        type: this.queryFilter.type,
        center_id: this.queryFilter.center_id,
        legal_entity: this.queryFilter.legal_entity,
      }
      this.$store.dispatch(GET_LIST_TAX_INVOICE, payload).then(res => {
        if (!res.error) {
          const data = res.data
          this.loading = true
          this.page = data.current_page
          this.lastPage = data.last_page
          this.total = data.total
          this.TaxInvoiceList = data.data.map(item => {
            return new TaxInvoiceModel(item)}) ?? []
          this.totalStudent = res.total
        }
      }).catch(e => {
        console.log(e, 'error')
      }).finally(() => {
        this.loading = false
      })
    },
    getParams() {
      const query = this.$route.query
      this.queryFilter.tax_code = query.tax_code ?? null
      this.queryFilter.amount_id = query.amount_id ?? null
      this.queryFilter.release_time = query.release_time ?? null
      this.queryFilter.release_code = query.release_code
      this.queryFilter.created_at = query.created_at ?? []
      this.queryFilter.user_name = query.user_name ?? null
      this.queryFilter.phone = query.phone ?? null
      this.queryFilter.status = query.status ? JSON.parse(`[${query.status}]`) : []
      this.queryFilter.type = query.type ? JSON.parse(`[${query.type}]`) : []
      this.queryFilter.center_id = query.center_id ?? null
      this.queryFilter.legal_entity = query.legal_entity ?? null
    },

    getAllCenterActive() {
      const payload  = {
        limit: 10000,
        is_edutalk: 1,
        status: 1,
      }
      this.$store.dispatch(GET_CENTER_TAG_E, payload).then(res => {
        if (!res.error) {
          this.centers = res.data?.data
        }
      })
    },

    async queryFilterTaxInvoice() {
      await this.$router.push({
        name: 'TaxInvoiceList',
        query: {
          tax_code: this.queryFilter.tax_code,
          amount_id: this.queryFilter.amount_id,
          release_code: this.queryFilter.release_code,
          user_name: this.queryFilter.user_name,
          phone: this.queryFilter.phone,
          created_at: this.queryFilter.created_at,
          release_time: this.queryFilter.release_time,
          status: this.queryFilter.status,
          type: this.queryFilter.type,
          center_id: this.queryFilter.center_id,
          legal_entity: this.queryFilter.legal_entity
        },
      })
    },

    cancelRelease(invoice, status) {
      this.taxInvoiceSelected = invoice
      this.confirmCancel = true
      this.statusSelectedInvoice = status
    },

    onlyNumberTaxCode(event) {
      this.queryFilter.tax_code = event.replace(/[^0-9]/g, '');
    },

    onlyNumberTaxInvoice(event) {
      this.queryFilter.amount_id = event.replace(/[^0-9]/g, '');
    },

    handleCancelRelease() {
      const payload = {
        id: this.taxInvoiceSelected.id,
        status: this.statusSelectedInvoice
      }
      this.$store.dispatch(UPDATE_STATUS_TAX_INVOICE, payload).then(res => {
        if (!res.error) {
          this.$message.success('Cập nhật trạng thái thành công')
          this.getTaxInvoiceList()
          this.confirmCancel = false
        }
      }).catch(e => {
        this.$message.error('Cập nhật trạng thái thất bại')
      })
    }
  }
}
</script>

<style scoped>
.bg-waiting {
  background: #FF9900;
}
.bg-success {
  background: #1BC5BD;
  color: white;
}
.bg-fail {
  background: #F50B0B;
  color: white;
}
.bg-cancel {
  color: white;
  background: #6E6E6E
}
.bg-blue-500 {
  background: #0066FF;
  color: white;
}
.display-flex-column {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.grid-filter {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 10px 60px;
}

@media screen and (max-width: 1560px) {
  .grid-filter {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 10px 30px;
  }
}
</style>